import type { EmailCampaignState } from "../types";

export const cloneCampaignState = (
  state: EmailCampaignState
): EmailCampaignState => JSON.parse(JSON.stringify(state));
